import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { AppShell } from "./components/AppShell";
import { OAuthCallback } from "./pages/OAuthCallback";
import { LoginPage } from "./pages/LoginPage";
import { ConversationsPage } from "./pages/ConversationsPage";
import { ConversationDetailPage } from "./pages/ConversationDetailPage";
import { SupportQueuePage } from "./pages/SupportQueuePage";
import { IdentityConflictsPage } from "./pages/IdentityConflictsPage";
import { ReviewQueuePage } from "./pages/ReviewQueuePage";
import { DealerProfilePage } from "./pages/DealerProfilePage";
import { DealersPage } from "./pages/DealersPage";
import { OutbidEngagementPage } from "./pages/OutbidEngagementPage";
import { Tb360BidEngagementPage } from "./pages/Tb360BidEngagementPage";
import { ObservabilityPage } from "./pages/ObservabilityPage";
import { ManualRecommendPage } from "./pages/ManualRecommendPage";
import { PlatformAdminPage } from "./pages/PlatformAdminPage";
import { capturePostLoginRedirect, isAuthenticated } from "./lib/auth";

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  if (!isAuthenticated()) {
    capturePostLoginRedirect(`${location.pathname}${location.search}${location.hash}`);
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/oauth/callback" element={<OAuthCallback />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <AppShell />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/conversations" replace />} />
          <Route path="conversations" element={<ConversationsPage />} />
          <Route path="conversation/:dealerId" element={<ConversationDetailPage />} />
          <Route path="dealers" element={<DealersPage />} />
          <Route path="support" element={<SupportQueuePage />} />
          <Route path="identity-conflicts" element={<IdentityConflictsPage />} />
          <Route path="review" element={<ReviewQueuePage />} />
          <Route path="dealer/:dealerId" element={<DealerProfilePage />} />
          <Route path="outbid-engagement" element={<OutbidEngagementPage />} />
          <Route path="tb360-bid-engagement" element={<Tb360BidEngagementPage />} />
          <Route path="observability" element={<ObservabilityPage />} />
          <Route path="recommend" element={<ManualRecommendPage />} />
          <Route path="platform-admin" element={<PlatformAdminPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
